module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Buscador Avanzado":"Buscador Avanzado","Todos":"Todos","Cine":"Cine","Series":"Series","Documentales":"Documentales"},"en":{},"ca":{"Buscador Avanzado":"Cercador avançat","Todos":"Tots","Cine":"Cine","Series":"Sèries","Documentales":"Documentals"}}')
  delete Component.options._Ctor
}
